export default "__VITE_ASSET__BObVsLM0__"